import { defineMessages } from "react-intl";

const messages = defineMessages({
    opus: {
        id: "meta.opus",
    },
    rhythm: {
        id: "meta.rhythm",
    },
    pitch: {
        id: "meta.pitch",
    },
});

export default messages;
